export enum Placements {
  Top = 'Top',
  Bottom = 'Bottom',
  Left = 'Left',
  Right = 'Right'
}



// WEBPACK FOOTER //
// ./src/app/common/enums/Placements.ts